export const alertModalTranslationJP = {
  Alert_Modal: {
    close: '閉じる',
  },
};
